<table aria-label="Virtual tour table">
  <thead>
    <tr>
      @for (group of groups; track group; let i = $index) {
        <th [id]="i === 4 ? 'tour-4' : (i === 5 ? 'tour-4-1' : (i === 6 ? 'tour-6' : ''))">
          <span
            [ngClass]="{ 'step-2': group.name === 'Ações' }"
            >{{ group.name }}</span
          >
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (rowData of dataTableInfo; track rowData; let rowIndex = $index) {
      <tr [id]="rowIndex === 0 ? 'tour-3' : ''">
        @for (cellData of rowData; track cellData; let colIndex = $index) {
          @if (colIndex === 6 && rowIndex === 0) {
            <td>
              <span>
                <button
                  mat-button=""
                  class="mat-focus-indicator mat-menu-trigger mat-button mat-button-base ng-star-inserted"
                  aria-haspopup="menu"
                >
                  <span class="mat-button-wrapper"
                    ><mat-icon
                      role="img"
                      fontset="material-icons"
                      class="mat-icon notranslate material-icons mat-icon-no-color"
                      aria-hidden="true"
                      data-mat-icon-type="font"
                      data-mat-icon-namespace="material-icons"
                      >more_vert</mat-icon
                    ></span
                  ><span matripple="" class="mat-ripple mat-button-ripple"></span
                  ><span class="mat-button-focus-overlay"></span>
                </button>
              </span>
            </td>
          } @else {
            <td [id]="rowIndex === 0 && isProfile(cellData) ? 'tour-5' : (getMfaTourId(cellData, rowIndex))">
              @if (cellData === '') { }
              @if (isProfile(cellData)) {
                {{ cellData }}
              }
              @if (isMfaStatus(cellData)) {
                <div class="d-flex justify-content-center">
                  <span class="mfa-status" [ngClass]="getMfaStatusClass(cellData)">{{ cellData }}</span>
                </div>
              }
              @if (!isProfile(cellData) && !isMfaStatus(cellData) && cellData !== '') {
                <div [ngClass]="cellData">{{ cellData }}</div>
              }
            </td>
          }
        }
      </tr>
    }
  </tbody>

  <div class="actions" [ngClass]="{ invisible: !isButtonActive }">
    <div class="mat-menu-content">
      <button
        id="tour-7"
        mat-menu-item=""
        data-testid="iconeVisualizarUsuario"
        class="mat-focus-indicator mat-menu-item"
        role="menuitem"
        aria-disabled="false"
      >
        <img
          alt="ícone de visualizar usuário"
          src="./assets/icons/icon_view_user.svg"
          class="icon"
        />Visualizar dados do usuário
        <div matripple="" class="mat-ripple mat-menu-ripple"></div>
      </button>
      <button
        id="tour-8"
        mat-menu-item=""
        class="mat-focus-indicator mat-menu-item"
        role="menuitem"
        aria-disabled="false"
      >
        <img
          alt="ícone de editar usuário"
          src="./assets/icons/icon_edit_user.svg"
          class="icon"
        />Editar usuário
        <div matripple="" class="mat-ripple mat-menu-ripple"></div>
      </button>
      <button
        id="tour-9"
        mat-menu-item=""
        class="mat-focus-indicator mat-menu-item"
        role="menuitem"
        aria-disabled="false"
      >
        <img
          alt="ícone de resetar senha do usuário"
          src="./assets/icons/icon_reset_password.svg"
          class="icon"
        />Redefinir senha do usuário
        <div matripple="" class="mat-ripple mat-menu-ripple"></div>
      </button>
      <button
        id="tour-10"
        mat-menu-item=""
        class="mat-focus-indicator mat-menu-item ng-star-inserted"
        role="menuitem"
        aria-disabled="false"
      >
        <img
          alt="Ícone de bloquear usuário"
          src="./assets/icons/icon_block_user.svg"
          class="icon"
        />Bloquear usuário
        <div matripple="" class="mat-ripple mat-menu-ripple"></div>
      </button>
      <button
        id="tour-11"
        mat-menu-item=""
        class="mat-focus-indicator mat-menu-item ng-star-inserted"
        role="menuitem"
        aria-disabled="false"
      >
        <img
          alt="Ícone de bloquear usuário"
          src="./assets/icons/icon_delete_user.svg"
          class="icon --delete-icon"
        />Excluir usuário
        <div matripple="" class="mat-ripple mat-menu-ripple"></div>
      </button>
    </div>
  </div>
</table>
